// categoryHelper.ts
let categoriesData: any[] = [];

export const setCategoriesData = (data: any[]) => {
    categoriesData = data;
};

export const getCategoryName = (categoryId: string) => {
    const categoryItem = categoriesData.find(cat => cat.value === categoryId);
    return categoryItem?.label || 'Unknown Category';
};